<script>
  import SankeyWrapperFlow from "./SankeyWrapperFlow.svelte";
  import FlowDataTables from "./FlowDataTables.svelte";
  import { get_flow_chart_data, get_flow_chart_data_without_split } from "./Utils.svelte";

  import jQuery from "jquery";

  window.jQuery = jQuery;
  window.$ = jQuery;

  export let flow_numbers_dict;
  export let sources_and_campains_data_table_dict;
  export let sources_and_campains_data_table_dict_countries;
  export let radio_buttons_split = 2;
  export let list_of_countries;
  export let list_of_countries_shorts;

  let what_happens_with_leads_data = false;

  $: {
    flow_numbers_dict;

    if (flow_numbers_dict) {
      if (radio_buttons_split == 2) {
        // console.log("flow_numbers_dict: ", flow_numbers_dict)

        what_happens_with_leads_data = get_flow_chart_data(flow_numbers_dict, window.$(window).width());
      } else {
        what_happens_with_leads_data = get_flow_chart_data_without_split(flow_numbers_dict, window.$(window).width());
      }
    }
  }

  // let what_happens_with_leads_data = {
  //   nodes: [
  //     { id: 'Leads', extra: 'Leads', color: '#d0d3d5', 'stroke-width': 2 },

  //     //Ebene 1:
  //     {
  //       id: 'MISC',
  //       extra: 'MISC',
  //       text_color: '#FFFFFF',
  //       color: '#dbc2cf',
  //       'stroke-width': 1,
  //       stroke: '#FFFFFF',
  //       shift_left: 'Leads' /*shift_down: 17,*/,
  //     },
  //     {
  //       id: 'EVT',
  //       extra: 'EVT',
  //       text_color: '#FFFFFF',
  //       color: '#9fa2b2',
  //       'stroke-width': 1,
  //       stroke: '#FFFFFF',
  //       shift_left: 'Leads' /*shift_down: 7,*/,
  //     },
  //     {
  //       id: 'ORG',
  //       extra: 'ORG',
  //       text_color: '#FFFFFF',
  //       color: '#3c7a89',
  //       'stroke-width': 1,
  //       stroke: '#FFFFFF',
  //       shift_left: 'Leads' /*shift_down: -3,*/,
  //     },
  //     {
  //       id: 'ADV',
  //       extra: 'ADV',
  //       text_color: '#FFFFFF',
  //       color: '#2e4756',
  //       'stroke-width': 1,
  //       stroke: '#FFFFFF',
  //       shift_left: 'Leads' /*shift_down: -13,*/,
  //     },

  //     //Ebene 2:
  //     { id: 'Lost Leads', extra: 'Lost Leads', color: '#f3f4f4', shift_x: -30, 'stroke-width': 1 },
  //     { id: 'Archived Leads', extra: 'Ar chi ved Leads', color: '#f3f4f4', shift_x: -30, 'stroke-width': 1 },
  //     { id: 'Open Leads', extra: 'Open Leads', color: '#f3f4f4', shift_x: -30, 'stroke-width': 1 },
  //     { id: 'OPP', extra: 'OPP', color: '#d0d3d5', shift_x: -30, 'stroke-width': 1 },

  //     //Ebene 3:
  //     { id: 'OPP_1', extra: '&nbsp;', text_color: '#FFFFFF', color: '#dbc2cf', 'stroke-width': 1, shift_left: 'OPP', stroke: '#FFFFFF' },
  //     { id: 'OPP_2', extra: '5%', text_color: '#FFFFFF', color: '#9fa2b2', 'stroke-width': 1, shift_left: 'OPP', stroke: '#FFFFFF' },
  //     { id: 'OPP_3', extra: '44%', text_color: '#FFFFFF', color: '#3c7a89', 'stroke-width': 1, shift_left: 'OPP', stroke: '#FFFFFF' },
  //     { id: 'OPP_4', extra: '51%', text_color: '#FFFFFF', color: '#2e4756', 'stroke-width': 1, shift_left: 'OPP', stroke: '#FFFFFF' },

  //     //Ebene 4:
  //     { id: 'Lost', extra: 'Lost', color: '#f3f4f4', shift_x: -30, 'stroke-width': 1 },
  //     { id: 'Open', extra: 'Open', color: '#f3f4f4', shift_x: -30, 'stroke-width': 1 },
  //     { id: 'WON OPP', extra: 'WON OPP', color: '#d0d3d5', shift_x: -30, 'stroke-width': 1 },

  //     //Ebene 5:
  //     { id: 'WON OPP1', extra: '10%', color: '#dbc2cf', text_color: '#FFFFFF', shift_left: 'WON OPP', 'stroke-width': 1 },
  //     { id: 'WON OPP2', extra: '10%', color: '#9fa2b2', text_color: '#FFFFFF', shift_left: 'WON OPP', 'stroke-width': 1 },
  //     { id: 'WON OPP3', extra: '10%', color: '#3c7a89', text_color: '#FFFFFF', shift_left: 'WON OPP', 'stroke-width': 1 },
  //     { id: 'WON OPP4', extra: '10%', color: '#2e4756', text_color: '#FFFFFF', shift_left: 'WON OPP', 'stroke-width': 1 },

  //     //Ebene 6:
  //     { id: 'NEW CUST', extra: 'NEW CUST', color: '#d0d3d5', shift_x: -30, 'stroke-width': 1 },
  //   ],
  //   links: [
  //     //Ebene 1:
  //     { source: 'Leads', target: 'MISC', value: 250, show_link: false, show_link_text: false },
  //     { source: 'Leads', target: 'EVT', value: 100, show_link: false, show_link_text: false },
  //     { source: 'Leads', target: 'ORG', value: 350, show_link: false, show_link_text: false },
  //     { source: 'Leads', target: 'ADV', value: 300, show_link: false, show_link_text: false },

  //     //Ebene 2:
  //     { source: 'MISC', target: 'Lost Leads', value: 150, show_link: true, show_link_text: false, color: '#dbc2cf' },
  //     { source: 'MISC', target: 'Archived Leads', value: 100, show_link: true, show_link_text: false, color: '#dbc2cf' },
  //     { source: 'EVT', target: 'Lost Leads', value: 25, show_link: true, show_link_text: false, color: '#9fa2b2' },
  //     { source: 'EVT', target: 'Archived Leads', value: 25, show_link: true, show_link_text: false, color: '#9fa2b2' },
  //     { source: 'EVT', target: 'Open Leads', value: 25, show_link: true, show_link_text: false, color: '#9fa2b2' },
  //     { source: 'EVT', target: 'OPP', value: 25, show_link: true, show_link_text: false, color: '#9fa2b2' },
  //     { source: 'ORG', target: 'Lost Leads', value: 50, show_link: true, show_link_text: false, color: '#3c7a89' },
  //     { source: 'ORG', target: 'Archived Leads', value: 100, show_link: true, show_link_text: false, color: '#3c7a89' },
  //     { source: 'ORG', target: 'Open Leads', value: 50, show_link: true, show_link_text: false, color: '#3c7a89' },
  //     { source: 'ORG', target: 'OPP', value: 150, show_link: true, show_link_text: false, color: '#3c7a89' },
  //     { source: 'ADV', target: 'Lost Leads', value: 50, show_link: true, show_link_text: false, color: '#2e4756' },
  //     { source: 'ADV', target: 'Archived Leads', value: 50, show_link: true, show_link_text: false, color: '#2e4756' },
  //     { source: 'ADV', target: 'Open Leads', value: 100, show_link: true, show_link_text: false, color: '#2e4756' },
  //     { source: 'ADV', target: 'OPP', value: 100, show_link: true, show_link_text: false, color: '#2e4756' },

  //     //Ebene 3:
  //     { source: 'OPP', target: 'OPP_1', value: 0, show_link: false, show_link_text: true, color: '#dbc2cf' },
  //     { source: 'OPP', target: 'OPP_2', value: 25, show_link: false, show_link_text: true, color: '#9fa2b2' },
  //     { source: 'OPP', target: 'OPP_3', value: 150, show_link: false, show_link_text: true, color: '#3c7a89' },
  //     { source: 'OPP', target: 'OPP_4', value: 100, show_link: false, show_link_text: true, color: '#2e4756' },

  //     //Ebene 4:
  //     { source: 'OPP_1', target: 'Lost', value: 0, show_link: false, show_link_text: false, color: '#dbc2cf' },
  //     { source: 'OPP_2', target: 'Lost', value: 5, show_link: true, show_link_text: false, color: '#9fa2b2' },
  //     { source: 'OPP_3', target: 'Lost', value: 50, show_link: true, show_link_text: false, color: '#3c7a89' },
  //     { source: 'OPP_4', target: 'Lost', value: 20, show_link: true, show_link_text: false, color: '#2e4756' },
  //     { source: 'OPP_1', target: 'Open', value: 0, show_link: false, show_link_text: false, color: '#dbc2cf' },
  //     { source: 'OPP_2', target: 'Open', value: 10, show_link: true, show_link_text: false, color: '#9fa2b2' },
  //     { source: 'OPP_3', target: 'Open', value: 50, show_link: true, show_link_text: false, color: '#3c7a89' },
  //     { source: 'OPP_4', target: 'Open', value: 40, show_link: true, show_link_text: false, color: '#2e4756' },
  //     { source: 'OPP_1', target: 'WON OPP', value: 0, show_link: false, show_link_text: false, color: '#dbc2cf' },
  //     { source: 'OPP_2', target: 'WON OPP', value: 10, show_link: true, show_link_text: false, color: '#9fa2b2' },
  //     { source: 'OPP_3', target: 'WON OPP', value: 50, show_link: true, show_link_text: false, color: '#3c7a89' },
  //     { source: 'OPP_4', target: 'WON OPP', value: 40, show_link: true, show_link_text: false, color: '#2e4756' },

  //     //Ebene 5:
  //     { source: 'WON OPP', target: 'WON OPP1', value: 0, show_link: false, show_link_text: true, color: '#dbc2cf' },
  //     { source: 'WON OPP', target: 'WON OPP2', value: 10, show_link: false, show_link_text: true, color: '#9fa2b2' },
  //     { source: 'WON OPP', target: 'WON OPP3', value: 50, show_link: false, show_link_text: true, color: '#3c7a89' },
  //     { source: 'WON OPP', target: 'WON OPP4', value: 40, show_link: false, show_link_text: true, color: '#2e4756' },

  //     //Ebene 6:
  //     { source: 'WON OPP1', target: 'NEW CUST', value: 0, show_link: true, show_link_text: false, color: '#dbc2cf' },
  //     { source: 'WON OPP2', target: 'NEW CUST', value: 10, show_link: true, show_link_text: false, color: '#9fa2b2' },
  //     { source: 'WON OPP3', target: 'NEW CUST', value: 50, show_link: true, show_link_text: false, color: '#3c7a89' },
  //     { source: 'WON OPP4', target: 'NEW CUST', value: 40, show_link: true, show_link_text: false, color: '#2e4756' },

  //     //TODO hier fehlt auch noch was
  //   ],
  // };
</script>

<div class="row" />

<div class="row" style="z-index: 2;">
  <div class="card-body card-for-svg" style="z-index: 3; margin-left: 50px;margin-right: 50px;">
    {#if what_happens_with_leads_data}
      {#if radio_buttons_split == 2}
        <SankeyWrapperFlow data={what_happens_with_leads_data} sticky={["Leads", "OPP", "New CUST"]} />
      {:else}
        <SankeyWrapperFlow data={what_happens_with_leads_data} sticky={[]} />
      {/if}
    {/if}
  </div>
</div>

<div class="row trenner-oben" />

<div class="row" style="margin-top: 30px;">
  <div class="col">
    <FlowDataTables
      {flow_numbers_dict}
      {sources_and_campains_data_table_dict}
      {sources_and_campains_data_table_dict_countries}
      {list_of_countries}
      {list_of_countries_shorts}
    />
  </div>
</div>

<style>
  .trenner-oben {
    margin-left: 20px;
    margin-right: 20px;
    border-top: 5px solid #d9d9d9;
  }

  .card-for-svg {
    width: 100%;
    height: 500px;
  }

  .center-div {
    display: flex;
    align-items: center;
    align-content: center;
  }

  .right {
    text-align: left;
  }

  .small-percentage-text {
    font-size: 10px;
    font-family: "arial";
  }

  .my-conversion-rate-text-small {
    font-family: "arial";
    /*padding-top:  0px;
    margin-top: 0px;
    margin-left: 10px;*/
    font-size: 12px;
    margin: 0 auto;
  }

  .my-conversion-rate-text {
    font-family: "arial";
    font-size: 16px;
    margin: 0 auto;
    /*margin-left: 20px;*/
  }

  input {
    width: 12%;
    padding-right: 5px;
  }

  p {
    padding-left: 10px;
  }

  .small-text {
    font-size: 50%;
  }

  .mycontent-right {
    border-left: 1px solid #50685b;
  }

  .vertical-center {
    display: flex;
    align-items: center;
  }

  .horizontal-center {
    display: flex;
    justify-content: center;
  }

  .span {
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
  }

  .info-box {
    background: #ffffff;
    border: 0.25pt solid #d9d9d9;
    color: #717171;
    font-size: 10px;
    height: 570px;
    width: 600;

    /*line-height: 10px;*/
    position: absolute;
    text-align: left;
    /*text-transform: uppercase;*/
    top: 30px;
    left: 30px;
    display: none;
    padding: 20px;
    z-index: 10;
    padding-bottom: 0px;
    padding-top: 15px;
  }

  .info-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*background-color: #eef3f0;*/
    border: 1px solid #999999;
    height: 25px;
    border-radius: 50%;
    width: 25px;
    text-align: center;
  }

  .info-circle:hover .info-box {
    display: block;
  }

  .info-circle:hover .info-i {
    display: none;
  }

  .circle {
    background-color: #fff;
    border: 7px solid red;
    height: 27px;
    border-radius: 50%;
    /*-moz-border-radius:50%;
    -webkit-border-radius:50%;*/
    width: 27px;
  }

  .circle-big {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #eef3f0;
    border: 2px solid #50685b;
    height: 80px;
    border-radius: 50%;
    width: 80px;
    text-align: center;
    margin: 0 auto;
  }

  .margin-korrektur-circle-and-text {
    margin-left: 0px;
    margin-right: 0px;
  }

  table,
  th,
  td {
    border-collapse: collapse;
    padding: 0px;
    margin: 0px;
  }
  td {
    border: none;
    border-top: none;
    border-bottom: none;
    border-right: none;
    border-left: none;
    padding-left: 10px;
    padding-right: 10px;
  }
  tr {
    border: none;
    border-top: none;
    border-bottom: none;
    border-right: none;
    border-left: none;
    border-color: #ffffff;
  }
  th {
    border: none;
    border-top: none;
    border-bottom: none;
    border-right: none;
    border-left: none;
    border-color: #ffffff;
  }
</style>
